// ============================================
// WOOCOMMERCE NOTICES PROCESSOR
// Reads notices from data attributes and displays them as toasts
// ============================================

/**
 * Process WooCommerce notices stored in data attributes
 * and display them using the toast system
 */
export function processWcNotices(): void {
	// Find all notice data containers
	const noticeContainers = document.querySelectorAll('.wc-notices-data');

	if (noticeContainers.length === 0) {
		return;
	}

	// Wait for mdToast to be available
	const displayNotices = () => {
		if (!(window as any).mdToast) {
			// Toast system not ready yet, try again
			setTimeout(displayNotices, 50);
			return;
		}

		noticeContainers.forEach((container) => {
			const noticesData = container.getAttribute('data-notices');
			const noticeType = container.getAttribute('data-notice-type') || 'default';

			if (!noticesData) {
				return;
			}

			try {
				const notices = JSON.parse(noticesData);
				if (Array.isArray(notices)) {
					notices.forEach((message: string) => {
						(window as any).mdToast(message, noticeType, 10000);
					});
				}

				// Remove the container after processing
				container.remove();
			} catch (e) {
				console.error('Error processing WooCommerce notices:', e);
			}
		});
	};

	// Start trying to display notices
	displayNotices();
}
